<h3 mat-dialog-title>Main Switchboard</h3>

<mat-dialog-content>
    <form name="myForm" class="example-form">
        <mat-form-field class="example-full-width">
            <mat-label>Name</mat-label>
            <input matInput type="text" name="name" [(ngModel)]="trailMSB.name">
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Contractor</mat-label>
            <input matInput type="text" name="contractor" [(ngModel)]="trailMSB.contractor">
        </mat-form-field>


        <mat-form-field class="example-full-width">
            <mat-label>Last Maintenance</mat-label>
            <textarea matInput type="text" name="last_maintenance" [(ngModel)]="trailMSB.last_maintenance"></textarea>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Modification</mat-label>
            <textarea matInput type="text" name="modification" [(ngModel)]="trailMSB.modification"></textarea>
        </mat-form-field>

        <mat-form-field class="example-full-width">
            <mat-label>Remark</mat-label>
            <textarea matInput type="text" name="remark" [(ngModel)]="trailMSB.remark"></textarea>
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-icon-button matTooltip="delete" (click)="onDeleteClick()">
        <mat-icon>delete_outline</mat-icon>
    </button>

    <span class="example-spacer"></span>

    <button mat-button (click)="onCancelClick()">Cancel</button>

    <button mat-button extended (click)="onUpdateClick()" [mat-dialog-close]="trailMSB" cdkFocusInitial>
        Update
    </button>
</mat-dialog-actions>
